import { FloatingFormItem, Group, SaveButton } from '@/components/_common';
import SupplierSelect from '@/components/Suppliers/SupplierSelect';
import { useUpdateMatrixMichelinSupplier } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { UpdateMatrixMichelinSupplier } from '@/core/domain/enterprise/Matrix/Matrix.types';
import { useWindowSize } from '@/hooks';
import { Col, Divider, Form, Row, Typography } from 'antd';
import { useEffect } from 'react';

interface FormValues {
  michelinSupplierId: number;
}

interface Props {
  matrixSettingsId?: number;
  michelinSupplierId?: number;
}

export default function MichelinSettings({
  matrixSettingsId,
  michelinSupplierId,
}: Props) {
  const { Text, Title } = Typography;

  const { width } = useWindowSize();
  const [form] = Form.useForm<FormValues>();

  const updateMatrixMichelinSupplier = useUpdateMatrixMichelinSupplier();

  useEffect(() => {
    if (michelinSupplierId) {
      form.setFieldsValue({
        michelinSupplierId,
      });
    }
  }, [michelinSupplierId]);

  const handleEditSettings = async () => {
    const values = await form.validateFields();

    if (matrixSettingsId) {
      const obj: UpdateMatrixMichelinSupplier = {
        supplierId: values.michelinSupplierId,
        matrixSettingsId,
      };

      await updateMatrixMichelinSupplier.mutateAsync(obj);
    }
  };

  return (
    <div className="page">
      <Group position="between">
        <Title level={width < 576 ? 5 : 4}>Michelin</Title>

        <SaveButton onClick={handleEditSettings}>Salvar</SaveButton>
      </Group>

      <Divider />

      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Text>
              Informe aqui um fornecedor padrão referente à Michelin para casos
              em que o produto não tenha vínculo com nenhum fornecedor em
              últimas compras
            </Text>
          </Col>

          <Col span={24}>
            <FloatingFormItem name="michelinSupplierId" label="Fornecedor">
              <SupplierSelect allowClear />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
